<template>
  <div class="tablaListado">
    <TableSkeleton v-show="loading" width="200px" />
    <a-table
      :columns="columns"
      :data-source="portfoliosInfo.items"
      :loading="loading"
      row-key="id"
      size="middle"
      :pagination="portfoliosInfo.pagination"
      :scroll="scrollStyle"
      @change="handleTableChange"
      v-show="!loading"
    >
      <template v-slot:customName>
        Nombre de la Campaña
        <a-tooltip>
          <template v-slot:title> Ordenar </template>
          <SwapOutlined :rotate="90" />
        </a-tooltip>
      </template>

      <template #id="{ record }">
        {{ formatId(record.id) }}
      </template>
      <template #name="{ record }">
        <span>{{ record.name }}</span>
      </template>

      <template #entity="{ record, text }" v-if="user?.customer?.type_business == 1">
        <div class="name">
          <div
            v-if="record.entity.logo"
            class="name__logo"
            :style="`background-image: url('${record.entity.logo}')`"
          />
          <div v-else class="name__logo name__logo--empty" />
          <span>{{ text.name }}</span>
        </div>
      </template>
      <template v-slot:customEntity v-if="user?.customer?.type_business == 1">
        Empresa
        <a-tooltip>
          <template v-slot:title> Ordenar </template>
          <SwapOutlined :rotate="90" />
        </a-tooltip>
      </template>

      <!-- <template #titleStatus>
        Estado
        <a-tooltip>
          <template v-slot:title> Ordenar </template>
          <SwapOutlined :rotate="90" />
        </a-tooltip>
      </template> -->

      <template #titleBases v-if="user?.customer?.enable_bases">
        <span> Bases </span>
      </template>
      <template #bases="{ record, text }" v-if="user?.customer?.enable_bases">
        <a @click="handleBasesClick(record)">
          {{ bases(text) }}
        </a>
      </template>
      <!-- <template #status="{ record }">
        <span>
          <a-tag v-if="record.status == 1" color="green"> Activo </a-tag>
          <a-tag v-else color="red"> Inactivo </a-tag>
        </span>
      </template> -->

      <template #schedule_management_type="{ record }">
        <span v-if="record.schedule_management_type === 1">Notificación simple</span>
        <span v-else>Caída automática</span>
      </template>

      <!-- Actions -->
      <template #actionScoped="{ record, index }">
        <a-popover placement="leftTop" :trigger="['click']">
          <template #content>
            <ModalAddAgents
              :record="record"
              :index="index"
              @onCloseModal="handleCloseModalWithRecord"
            />

            <a-button
              block
              class="table-cell__actions-btn"
              :id="`edit-typification-button-${index}`"
              type="text"
            >
              <router-link
                class="table-cell__actions-btn"
                :to="`/operations/campaigns/${record.id}`"
              >
                <TypificationsIcon size="16" />
                <span v-if="record.num_tipificactions > 0">Editar tipificación</span>
                <span v-else>Agregar tipificación</span>
              </router-link>
            </a-button>

            <a-button
              block
              class="table-cell__actions-btn"
              type="text"
              @click="handleShowModalDashboard($event, record, 'dashboard')"
            >
              <PieChartOutlined />
              <p>Ver dashboard</p>
            </a-button>

            <a-button
              block
              :id="`edit-portfolio-${index}-btn`"
              class="table-cell__actions-btn"
              type="text"
              @click="handleShowModalWithRecord($event, record, 'edit')"
            >
              <EditOutlined />
              <p>Editar campaña</p>
            </a-button>

            <a-button
              block
              class="table-cell__actions-btn"
              type="text"
              danger
              @click="handleDeleteCampaigns($event, record, 'delete')"
            >
              <DeleteOutlined />
              <p>Eliminar campaña</p>
            </a-button>
          </template>
          <a-button :id="`portfolios-actions-popover-${index}`" type="text">
            <EllipsisOutlined />
          </a-button>
        </a-popover>
      </template>
    </a-table>

    <PortfolioModal
      v-if="openModalType === 'edit'"
      :open="true"
      :portfolio="record"
      is-edit
      @update:open="handleCloseModalWithRecord"
      @update="handleUpdate"
    />
    <ModalDeleteCampaign
      :record="record"
      v-if="record && openModalType === 'delete'"
      @onCloseModal="handleCloseModalWithRecord"
      @update="handleUpdate"
    />
    <ModalDashboardCampaign
      :key="keyDashboard"
      :record="record"
      :idPortfolio="idPortfolio"
      :name="namePortfolio"
      v-if="record && openModalType === 'dashboard'"
      @onCloseModal="handleCloseModalWithRecord"
      @update="handleUpdate"
    />
  </div>
</template>

<script>
import ModalDeleteCampaign from "../modals/campaigns/ModalDeleteCampaign.vue";
import ModalDashboardCampaign from "@/app/entities/components/modals/campaigns/modalDashboard/ModalDashboardCampaign.vue";

import ModalAddAgents from "../modals/campaigns/modalAgents/ModalAddAgents.vue";
import TableSkeleton from "@/app/shared/components/skeletons/TableSkeleton.vue";

import { defineComponent } from "vue";
import {
  SwapOutlined,
  DeleteOutlined,
  EditOutlined,
  PieChartOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons-vue";
import { getWalletsTableColumns } from "@/app/entities/utils/constants";
import { fetchDashboardByPortfolio } from "../../services";

import { EllipsisOutlined } from "@ant-design/icons-vue";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import TypificationsIcon from "@/app/shared/components/icons/TypificationsIcon.vue";
import PortfolioModal from "@/app/entities/components/modals/campaigns/PortfolioModal.vue";
import { fetchValidatePortfolioBots } from "@/app/entities/services";
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";

export default defineComponent({
  name: "TableWallets",
  components: {
    ModalAddAgents,
    SwapOutlined,
    DeleteOutlined,
    EditOutlined,
    ModalDeleteCampaign,
    PieChartOutlined,
    ModalDashboardCampaign,
    TypificationsIcon,
    EllipsisOutlined,
    PortfolioModal,
    TableSkeleton,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const columns = getWalletsTableColumns(props.user?.customer?.enable_bases);

    const { scrollStyle } = useScrollResize({ xAxis: false });

    return {
      columns,
      scrollStyle,
    };
  },
  data() {
    return {
      record: null,
      openModalType: "",
      namePortfolio: "",
      keyDashboard: 0,
      idPortfolio: 0,
      recordUsers: null,
    };
  },
  computed: {
    portfoliosInfo() {
      return this.$store.getters["getFilteredPortfoliosInfo"];
    },
    trunks() {
      return this.$store.getters["getTrunkList"];
    },
    // optionPushTrunks() {
    //   const option = this.trunks;
    //   option.push({
    //     voip_provider: null,
    //     name: "Sin troncal VOIP",
    //   });
    //   return option;
    // },
  },
  watch: {
    optionPushTrunks(value) {
      if (value) {
        console.log(value);
      }
    },
    portfoliosInfo() {
      const portfolioId = this.$route.query.portfolioId;

      if (!portfolioId) return;

      this.record = this.portfoliosInfo.items.find((p) => p.id === Number(portfolioId));
      this.openModalType = "edit";
    },
  },
  // created() {
  //   this.handleFetchPortafolios();
  // },
  methods: {
    handleCloseModalWithRecord() {
      this.record = null;
      this.openModalType = "";
    },
    async handleShowModalDashboard(event, record, type) {
      this.keyDashboard++;
      this.namePortfolio = record.name;
      const response = await fetchDashboardByPortfolio(record.id);
      this.record = response.data;
      this.idPortfolio = record.id;
      this.openModalType = type;
    },
    handleShowModalUsers(event, record) {
      this.recordUsers = record;
    },
    handleShowModalWithRecord(event, record, type) {
      this.record = record;
      this.openModalType = type;
    },
    async handleErrorModal(title, botIA, chatBot) {
      const text = botIA.length > 0 && chatBot.length > 0
          ? "Inactiva los chatbots y bots AI vinculados, o reemplaza la cola de transferencia en los chatbots o la cola seleccionada en los bots AI."
          : "Inactiva los bots AI vinculados o reemplaza la cola por otra en su configuración.";

      Modal.confirm({
        title: title,
        icon: createVNode(InfoCircleOutlined),
        content:  createVNode("div", { class: "inactive-bot-modal" }, [
                  createVNode("p", { class: "text-base font-medium mb-2" }, text),
                  // ChatBots
                  chatBot.length > 0
                    ? createVNode("div", {}, [
                        createVNode(
                          "span",
                          { class: "font-medium mb-1" },
                          "ChatBots vinculados"
                        ),
                        createVNode(
                          "ul",
                          { class: "list-disc list-inside text-sm text-gray-600" },
                          chatBot.map((c) => createVNode("li", { key: c }, c))
                        ),
                      ])
                    : null,
                  botIA.length > 0
                    ? createVNode("div", {}, [
                        // Bots AI
                        createVNode(
                          "span",
                          { class: "font-medium mb-1" },
                          "Bots AI vinculados"
                        ),
                        createVNode(
                          "ul",
                          { class: "list-disc list-inside text-sm text-gray-600 mb-2" },
                          botIA.map((bot) => createVNode("li", { key: bot }, bot))
                        ),

                        
                      ])
                    : null,
                ]),
                
        centered: true,
        okText: "Entendido",
        cancelButtonProps: { style: { display: "none" } },
      });
    },
    async handleValidatePortfolioBots(record) {
      try {
          console.log(record?.id, 'handleValidatePortfolioBots record id');
        if (record?.id) {
          const response = await fetchValidatePortfolioBots(record?.id);
        }
      } catch (error) {
        if (error.status === 400) {
          const errorMessage = error?.getErrorMessage?.() || "";
          const regex = /([A-Za-z_]\w*):\s*([\s\S]*?)(?=(?:[A-Za-z_]\w*):|$)/gu;
          let match;
          const data = {};

          while ((match = regex.exec(errorMessage)) !== null) {
            const key = match[1];
            const value = match[2];
            data[key] = value;
          }

          // Ahora puedes acceder a cada valor
          const chatbot_total = Number(data.chatbot_total) || 0;
          const beexai_total = Number(data.beexai_total) || 0;
          const message = [
            chatbot_total > 0 && beexai_total > 0
            ? `Esta campaña no puede ser eliminada porque está vinculada a ${chatbot_total} chatbot${chatbot_total > 1 ? "s" : ""} y ${beexai_total} bot${beexai_total > 1 ? "s AI" : " AI"} activos.`
            : chatbot_total > 0 
            ? `Esta campaña no puede ser eliminada porque está vinculada a ${chatbot_total} chatbot${chatbot_total > 1 ? "s activos" : " activo"}.`
            : beexai_total > 0 
            ? `Esta campaña no puede ser eliminada porque está vinculada a ${beexai_total} bot${beexai_total > 1 ? "s AI activos" : " AI activo"}.`
            : ""
            ].filter(Boolean).join(" ");

          const chatBot = data.chatbot ? data.chatbot.split(",").map(v => v.trim()) : [];
          const beexAI = data.beexai ? data.beexai.split(",").map(v => v.trim()) : [];
          await this.handleErrorModal(
            message,
            beexAI,
            chatBot
          );
        } else {
          this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo.");
        }
        throw error;
      }
    },
    async handleDeleteCampaigns(event, record, type) {
      try {
        await this.handleValidatePortfolioBots(record);
        this.record = record;
        this.openModalType = type;
      } catch (error) {
        console.error("Error al validar la campaña antes de eliminar:", error);
      }
    },
    bases(counter) {
      if (!counter) return "Sin bases";
      const label = counter == 1 ? "base" : "bases";
      return `${counter} ${label}`;
    },
    agents(counter) {
      if (!counter) return "Agregar";
      const label = counter == 1 ? "usuario" : "usuarios";
      return `${counter} ${label}`;
    },
    handleFetchPortafolios() {
      // this.$store.dispatch("fetchAllPortfoliosByEntity", {});
      this.handleUpdate();
    },
    handleTableChange(pagination) {
      // this.$store.dispatch("fetchAllPortfoliosByEntity", {
      //   pagination: pagination,
      // });
      this.handleUpdate(pagination.current);
    },
    handleBasesClick(portfolio) {
      this.$store.dispatch("setSelectedEntity", portfolio.entity.id);
      this.$store.dispatch("setSelectedPortfolio", portfolio.id);
      this.$router.push("/operations/bases");
    },
    formatId(id) {
      return ("0" + id).slice(-2);
    },
    handleUpdate(page) {
      this.$emit("update", page);
    },
  },
});
</script>

<style lang="sass" scoped>
@import '@/app/shared/assets/table-cell-actions.sass'

:deep(.ant-table-thead > tr > th .ant-table-column-sorter)
  display: none
:deep(.ant-table-thead > tr > th)
  // padding: 10px !important
.name
  display: flex
  align-items: center
  position: relative

  &__logo
    display: block
    width: 25.63px
    height: 25.24px
    background-size: cover
    background-position: center
    border-radius: 50%
    margin-right: 12px

    &--empty
      flex: 0 0 auto
      background-image: url('../../assets/briefcase-blue.svg')

.cell-agents
  display: flex

.cell--actions
  display: flex

.image__typifications
  position: relative
  top: -1px


// ICONS SIZE
.ant-popover-inner-content .anticon
  font-size: 16px
</style>
